/* eslint-disable */
import axios from 'axios';

export const postVisite = (params) => {
    return axios.post(`https://winbet.partners/api/partners/stream-events/visite`, params);
};